import React, {Component} from "react";

class StakeWallet extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="breadcrumb-area staking-area">
                    <h3>STAKE</h3>
                    <div className="stake-input">
                        <input placeholder="0 Light-BNB LP"/>
                        <button>Max</button>
                    </div>
                    <button>Connect your wallet to Stake</button>
                </div>
            </React.Fragment>
        )
    }
}

export default StakeWallet;